import type { FormControlLabelProps } from '@mui/material/FormControlLabel';
import type { TypographyProps } from '@mui/material/Typography';

import {
  StyledFormControlLabel,
  StyledFormLabel,
} from './FormControlLabel.styled.js';

export const FormControlLabel = ({
  labelProps,
  ...props
}: FormControlLabelProps & { labelProps?: TypographyProps }) => {
  const label
    = typeof props?.label === 'string'
      ? (
          <StyledFormLabel data-sentry-unmask {...labelProps}>{props?.label ?? ''}</StyledFormLabel>
        )
      : (
          props?.label
        );
  return <StyledFormControlLabel {...props} label={label} />;
};
